import CloseRounded from "@mui/icons-material/CloseRounded";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { grey } from "@mui/material/colors";
import { useMemo } from "react";
import Flx from "../layout/Flx";
import Htag from "../typography/Htag";
import ModalContent from "./shared/ModalContent";
import Txt from "../typography/Txt";

const offset = 14;
// const offset = 24;
const SideCardModal = ({
  show,
  onClose,
  title,
  children,
  icon,
  description,
  drawerWidth = "800px",
  suppressBodyPadding,
  suppressBodyOverflow,
  bodySx,
  hideHeader,
  maxWidth = false,
  headerSx,
}) => {
  const handleClose = (_event, reason) => {
    // You can inspect `reason` if you only want to close on backdrop/escKey
    // e.g. if (reason === "backdropClick" || reason === "escapeKeyDown") { onClose(false); }
    onClose(false);
  };
  return (
    <>
      <Dialog
        open={show}
        onClose={handleClose}
        maxWidth={maxWidth}
        PaperProps={{
          sx: {
            width: drawerWidth,
            maxHeight: `calc(100% - ${offset * 2}px)`,
            borderRadius: "4px",
            // borderRadius: "8px",
            m: 0,
            position: "absolute",
            maxWidth: "36vw",
            minWidth: "800px",
            // minWidth: "500px",
            height: `calc(100% - ${offset * 2}px)`,
            // maxHeight: `calc(100% - ${offset * 2}px)`,
            right: offset,
            top: offset,
          },
        }}
      >
        {hideHeader ? null : (
          <Header
            title={title}
            description={description}
            onClose={onClose}
            sx={headerSx}
            icon={icon}
          />
        )}
        <Body
          suppressBodyPadding={suppressBodyPadding}
          suppressBodyOverflow={suppressBodyOverflow}
          sx={bodySx}
        >
          {children}
        </Body>
      </Dialog>
    </>
  );
};

const Header = ({ title, description, onClose, icon, sx }) => {
  const styles = useMemo(() => {
    let sty = {
      position: "relative",
      overflow: "hidden",
      flexGrow: 0,
      flexShrink: 0,
      borderBottom: `1px solid ${grey[300]}`,
      p: 2,
      // py: 2,
      // boxShadow: `0 1px 2px ${shadow1},0 -1px ${mediaInnerBorder} inset,0 2px 1px -1px ${shadowInset} inset`,
    };

    return {
      ...sty,
      ...sx,
    };
  }, [sx]);
  return (
    <>
      <ModalContent sx={styles}>
        <Flx fw jb ac>
          <RenderedTitle icon={icon} title={title} description={description} />
          <Flx ac g={0}>
            <Tooltip title={"Close"} arrow>
              <IconButton
                // color="primary"
                size="small"
                sx={{ marginLeft: 1, borderRadius: "4px" }}
                onClick={() => onClose(false)}
              >
                <CloseRounded />
              </IconButton>
            </Tooltip>
          </Flx>
        </Flx>
      </ModalContent>
    </>
  );
};

const RenderedTitle = ({ icon, title, description }) => {
  if (icon) {
    return (
      <Flx g={0.8} sx={{ ".MuiSvgIcon-root": { fontSize: "18px", mt: 0.3 } }}>
        {icon}
        <TitleDescriptionContent title={title} description={description} />
      </Flx>
    );
  }

  return <TitleDescriptionContent title={title} description={description} />;
};

const TitleDescriptionContent = ({ title, description }) => {
  return (
    <Flx column gap={0.2}>
      <Htag sx={{ fontWeight: "bold" }} h2>
        {title}
      </Htag>
      <Txt secondary>{description}</Txt>
    </Flx>
  );
};

const Body = ({ children, suppressBodyPadding, suppressBodyOverflow, sx }) => {
  const styles = useMemo(() => {
    let sty = { position: "relative" };

    if (suppressBodyPadding) {
      sty = { ...sty, padding: 0 };
    }
    if (suppressBodyOverflow) {
      sty = { ...sty, overflow: "hidden" };
    }
    return {
      ...sty,
      ...sx,
    };
  }, [sx, suppressBodyPadding, suppressBodyOverflow]);
  return (
    <>
      <ModalContent sx={styles}>{children}</ModalContent>
    </>
  );
};

// import CloseRounded from "@mui/icons-material/CloseRounded";
// import Dialog from "@mui/material/Dialog";
// import IconButton from "@mui/material/IconButton";
// import Tooltip from "@mui/material/Tooltip";
// import { grey } from "@mui/material/colors";
// import { useMemo } from "react";
// import Flx from "../layout/Flx";
// import Htag from "../typography/Htag";
// import ModalContent from "./shared/ModalContent";

// const offset = 14;
// // const offset = 24;
// const SideCardModal = ({
//   show,
//   onClose,
//   title,
//   children,
//   icon,
//   drawerWidth = "800px",
//   suppressBodyPadding,
//   suppressBodyOverflow,
//   bodySx,
//   hideHeader,
//   maxWidth = false,
//   headerSx,
// }) => {
//   const handleClose = (_event, reason) => {
//     // You can inspect `reason` if you only want to close on backdrop/escKey
//     // e.g. if (reason === "backdropClick" || reason === "escapeKeyDown") { onClose(false); }
//     onClose(false);
//   };
//   return (
//     <>
//       <Dialog
//         open={show}
//         onClose={handleClose}
//         maxWidth={maxWidth}
//         PaperProps={{
//           sx: {
//             width: drawerWidth,
//             maxHeight: `calc(100% - ${offset * 2}px)`,
//             borderRadius: "4px",
//             // borderRadius: "8px",
//             m: 0,
//             position: "absolute",
//             maxWidth: "36vw",
//             minWidth: "800px",
//             // minWidth: "500px",
//             height: `calc(100% - ${offset * 2}px)`,
//             // maxHeight: `calc(100% - ${offset * 2}px)`,
//             right: offset,
//             top: offset,
//           },
//         }}
//       >
//         {hideHeader ? null : (
//           <Header title={title} onClose={onClose} sx={headerSx} icon={icon} />
//         )}
//         <Body
//           suppressBodyPadding={suppressBodyPadding}
//           suppressBodyOverflow={suppressBodyOverflow}
//           sx={bodySx}
//         >
//           {children}
//         </Body>
//       </Dialog>
//     </>
//   );
// };

// const Header = ({ title, onClose, icon, sx }) => {
//   const styles = useMemo(() => {
//     let sty = {
//       position: "relative",
//       overflow: "hidden",
//       flexGrow: 0,
//       flexShrink: 0,
//       borderBottom: `1px solid ${grey[300]}`,
//       p: 2,
//       // py: 2,
//       // boxShadow: `0 1px 2px ${shadow1},0 -1px ${mediaInnerBorder} inset,0 2px 1px -1px ${shadowInset} inset`,
//     };

//     return {
//       ...sty,
//       ...sx,
//     };
//   }, [sx]);
//   return (
//     <>
//       <ModalContent sx={styles}>
//         <Flx fw jb ac>
//           {icon ? (
//             <Flx ac g={0.8} sx={{ ".MuiSvgIcon-root": { fontSize: "18px" } }}>
//               {icon}
//               <Htag sx={{ fontWeight: "bold" }} h2>
//                 {title}
//               </Htag>
//             </Flx>
//           ) : (
//             <Htag h2>{title}</Htag>
//           )}

//           <Flx ac g={0}>
//             <Tooltip title={"Close"} arrow>
//               <IconButton
//                 // color="primary"
//                 size="small"
//                 sx={{ marginLeft: 1, borderRadius: "4px" }}
//                 onClick={() => onClose(false)}
//               >
//                 <CloseRounded />
//               </IconButton>
//             </Tooltip>
//           </Flx>
//         </Flx>
//       </ModalContent>
//     </>
//   );
// };

// const Body = ({ children, suppressBodyPadding, suppressBodyOverflow, sx }) => {
//   const styles = useMemo(() => {
//     let sty = { position: "relative" };

//     if (suppressBodyPadding) {
//       sty = { ...sty, padding: 0 };
//     }
//     if (suppressBodyOverflow) {
//       sty = { ...sty, overflow: "hidden" };
//     }
//     return {
//       ...sty,
//       ...sx,
//     };
//   }, [sx, suppressBodyPadding, suppressBodyOverflow]);
//   return (
//     <>
//       <ModalContent sx={styles}>{children}</ModalContent>
//     </>
//   );
// };

export default SideCardModal;
